export const getTokenFromLocalStorage = () => {
  return localStorage.getItem('token')?.replace(/["']/g, '');
};

export const getTokenTypeFromLocalStorage = () => {
  return localStorage.getItem('token_type')?.replace(/["']/g, '');
};

export const getMerchantTokenFromLocalStorage = () => {
  return localStorage.getItem('merchant_token')?.replace(/["']/g, '');
};
